import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('打印箱唛'),
      "data-sign": "wrapper_inbound_print_box_mark_modal",
      "width": 800
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData,
      "data-sign": "wrapper_inbound_print_box_mark_form",
      "rules": _vm.formDataRule,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    staticClass: "no-margin",
    attrs: {
      "fbu-analyse-name": $t("\u6253\u5370"),
      "required": "",
      "label": _vm.t('打印')
    }
  }, [_c('a-form-model-item', {
    staticClass: "form-item",
    attrs: {
      "prop": "board_no_start"
    }
  }, [_c('a-input-number', {
    staticClass: "form-item",
    attrs: {
      "min": 1
    },
    model: {
      value: _vm.formData.board_no_start,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "board_no_start", $$v);
      },
      expression: "formData.board_no_start"
    }
  })], 1), _vm._v(" - "), _c('a-form-model-item', {
    staticClass: "form-item",
    attrs: {
      "prop": "board_no_end"
    }
  }, [_c('a-input-number', {
    staticClass: "form-item",
    attrs: {
      "min": 1
    },
    model: {
      value: _vm.formData.board_no_end,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "board_no_end", $$v);
      },
      expression: "formData.board_no_end"
    }
  })], 1), _c('div', {
    staticClass: "form-item ml-5"
  }, [_vm._v(" " + _vm._s(_vm.t('箱')) + " ")])], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6570\u91CF"),
      "prop": "print_num",
      "label": _vm.t('数量')
    }
  }, [_c('a-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: _vm.formData.print_num,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "print_num", $$v);
      },
      expression: "formData.print_num"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6253\u5370\u5C3A\u5BF8"),
      "prop": "print_size",
      "label": _vm.t('打印尺寸')
    }
  }, [_c('a-radio-group', {
    attrs: {
      "name": "radioGroup"
    },
    model: {
      value: _vm.formData.print_size,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "print_size", $$v);
      },
      expression: "formData.print_size"
    }
  }, _vm._l(_vm.boxPrintSizeEnum, function (item, index) {
    return _c('a-radio', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6253\u5370\u9884\u89C8"),
      "label": _vm.t('打印预览')
    }
  }, [_c('div', {
    staticClass: "barcode-preview-box"
  }, [_c('div', {
    staticClass: "barcode-preview-title"
  }, [_vm._v("PKG")]), _c('div', {
    staticClass: "barcode-preview-order-msg mt-10 mb-10"
  }, [_c('span', [_c('span', {
    staticClass: "mr-20"
  }, [_vm._v("PKG Inbound List")]), _c('span', [_vm._v(_vm._s(_vm.data.order_code))])]), _c('span', [_vm._v("QTY：" + _vm._s(_vm.packageNumTotal))])]), _c('img', {
    staticClass: "barcode-preview-image",
    attrs: {
      "src": require("@/assets/images/barcode.png")
    }
  }), _c('div', {
    staticClass: "barcode-preview-number"
  }, [_vm._v(_vm._s(_vm.data.order_code) + "-1")]), _c('div', {
    staticClass: "barcode-preview-footer"
  }, [_c('span', [_vm._v("Container 1/" + _vm._s(_vm.boxTotal))]), _c('span', {
    staticClass: "barcode-preview-customer"
  }, [_vm._v(_vm._s(_vm.userInfo.customer_code))])])])])], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "wrapper_inbound_print_box_mark_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-sign": "wrapper_inbound_print_box_mark_submit",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };